export const GET_MIN_MAX_FAILURE_REQUEST = "GET_MIN_MAX_FAILURE_REQUEST";
export const GET_MIN_MAX_FAILURE_SUCCESS = "GET_MIN_MAX_FAILURE_SUCCESS";
export const GET_MIN_MAX_FAILURE_FAILURE = "GET_MIN_MAX_FAILURE_FAILURE";


export const GET_MIN_MAX_FAILURE_DOWNLOAD_REQUEST = "GET_MIN_MAX_FAILURE_DOWNLOAD_REQUEST";
export const GET_MIN_MAX_FAILURE_DOWNLOAD_SUCCESS = "GET_MIN_MAX_FAILURE_DOWNLOAD_SUCCESS";
export const GET_MIN_MAX_FAILURE_DOWNLOAD_FAILURE = "GET_MIN_MAX_FAILURE_DOWNLOAD_FAILURE";
